import { ArrowUpRight, Bell } from "lucide-react";
import { canBuy } from "../lib/format";
import { scrollToId } from "../lib/scroll";
import { useNavigate, useLocation } from "react-router-dom";

export const TicketButton = ({ concert, testId, label = "Get Tickets", className = "" }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (canBuy(concert)) {
    return (
      <a
        data-testid={testId}
        href={concert.ticket_url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${label} for ${concert.artist} (opens external ticketing site)`}
        className={`btn-primary ${className}`}
      >
        {label} <ArrowUpRight size={16} />
      </a>
    );
  }
  if (concert?.status === "Coming Soon" && !concert?.is_past) {
    const alert = () => (pathname === "/" ? scrollToId("signup") : navigate("/#signup"));
    return (
      <button data-testid={testId} onClick={alert} className={`btn-ghost ${className}`}>
        <Bell size={15} /> Get Alerts
      </button>
    );
  }
  return (
    <button data-testid={testId} disabled className={`btn-ghost cursor-not-allowed opacity-60 ${className}`}>
      {concert?.is_past ? "Event Ended" : "Sold Out"}
    </button>
  );
};
